import React from 'react';
import { Box, Typography } from '@mui/material';
import { AnnouncementOutlined } from '@mui/icons-material';

import { DashboardMetricCardWrapper } from 'components/dashboard-metric-card';
import { useScansCount } from 'store/apis';
import { TotalCard } from './total-card';

interface ChartTotalScansProps {
  buildingId: number;
  start: string;
  end: string;
  type: string;
  title: string;
}

export const ChartTotalScans = ({ buildingId, start, end, type, title }: ChartTotalScansProps) => {
  const { total, isFetching } = useScansCount({ buildingId, start, end, type });

  return (
    <DashboardMetricCardWrapper title={title} loading={isFetching} loadingText="Loading scans...">
      {total === 0 && (
        <Box sx={{ textAlign: 'center' }}>
          <AnnouncementOutlined color="primary" sx={{ fontSize: 40 }} />

          <Typography color="primary" sx={{ marginTop: 2 }}>
            No scans info
          </Typography>
        </Box>
      )}

      {total > 0 && <TotalCard value={total} valueUnit="SCANS" />}
    </DashboardMetricCardWrapper>
  );
};
